import { Route, Routes } from "react-router-dom"


import { IncidentsMapLayersRouter } from "../../../modules/incidents/routers/IncidentsMapLayersRouter"
import { RiskZonesMapLayersRouter } from "../../../modules/riskZones/routers/RiskZonesMapLayersRouter"
import { SpeedingsMapLayersRouter } from "../../../modules/speedings/routers/SpeedingsMapLayersRouter"
import { MODULE_INCIDENTS, MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "../../constants/modules"

export const SafetyDesktopMapRouter = () => {

    return (
        <Routes>
            <Route
                element={
                    <RiskZonesMapLayersRouter />
                }
                path={`/${MODULE_RISK_ZONES}/*`}
            />
            <Route
                element={
                    <SpeedingsMapLayersRouter />
                }
                path={`/${MODULE_SPEEDINGS}/*`}
            />
            <Route
                element={
                    <IncidentsMapLayersRouter />
                }
                path={`/${MODULE_INCIDENTS}/*`}
            />
        </Routes>
    )
}